// Corporate Executive Positioning Data for Vijay Kadechkar

export const heroData = {
  tagline: "Head of Productions | Vertical Head | Business Head | Strategic Business Consultant",
  heroImage: "https://customer-assets.emergentagent.com/job_precision-at-scale/artifacts/deugk7gc_DC660060-F250-43F6-AD29-75E47FF4E7F3.jpeg",
  stats: [
    { id: "years", value: "20+", label: "Years Experience" },
    { id: "artists", value: "1,000+", label: "Film & TV Artists" },
    { id: "productions", value: "100+", label: "International Productions" }
  ]
};

export const executiveProfile = {
  name: "Vijay Kadechkarr",
  image: "https://customer-assets-agu9un31.emergentagent.net/job_precision-at-scale/artifacts/s8wngvmx_D1413F42-CFD1-4D87-B426-664276F6A450.PNG",
  title: "Head of Productions | Vertical Head | Strategic Business Consultant",
  summary: "Seasoned media and entertainment executive with over two decades of experience across Film, Television, Talent Management, and Production operations. Proven expertise in P&L management, business development, scaling content ecosystems, and driving revenue growth across Media & Entertainment verticals.",
  expertise: [
    { id: "prod-ops", text: "Production & Operations Leadership" },
    { id: "biz-dev", text: "Business Development & Strategy" },
    { id: "film-tv", text: "Film & Television Management" },
    { id: "talent", text: "Talent Management & Negotiations" },
    { id: "media-ent", text: "Media & Entertainment Verticals" },
    { id: "pnl", text: "P&L Management & Financial Strategy" }
  ]
};

export const coreDomains = [
  {
    id: 1,
    title: "Film & Television",
    icon: "Film",
    description: "Film production, TV content development, and broadcast management",
    highlights: [
      "100+ film & television productions",
      "Multi-platform content strategy",
      "Box office & broadcast optimization"
    ]
  },
  {
    id: 2,
    title: "Talent Management",
    icon: "Users",
    description: "Artist representation, contract negotiation, and talent ecosystem development",
    highlights: [
      "Managed 1,000+ film & TV artists",
      "High-value contract negotiations",
      "Talent portfolio optimization"
    ]
  },
  {
    id: 3,
    title: "Production Operations",
    icon: "Clapperboard",
    description: "Large-scale production execution, budgeting, and operational management",
    highlights: [
      "100+ international productions",
      "Budget optimization & control",
      "Cross-border production expertise"
    ]
  },
  {
    id: 4,
    title: "Business Development",
    icon: "TrendingUp",
    description: "Strategic partnerships, revenue growth, and market expansion",
    highlights: [
      "Business transformation initiatives",
      "Strategic partnerships & alliances",
      "Revenue maximization frameworks"
    ]
  },
  {
    id: 5,
    title: "Media & Entertainment",
    icon: "Globe",
    description: "OTT platforms, broadcast networks, and entertainment ecosystem management",
    highlights: [
      "Multi-vertical media operations",
      "OTT & broadcast strategy",
      "Entertainment ecosystem scaling"
    ]
  },
  {
    id: 6,
    title: "Vertical Leadership",
    icon: "Lightbulb",
    description: "End-to-end vertical management across production, content, and distribution",
    highlights: [
      "P&L ownership & accountability",
      "Vertical strategy & execution",
      "Cross-functional team leadership"
    ]
  }
];

export const careerJourney = [
  {
    id: "rgv-2005",
    year: "2005",
    company: "Ram Gopal Varma Productions",
    role: "Strategic Production & Talent Foundations",
    description: "Launched career in production management under India's maverick filmmaker. Built foundational skills in creative execution and talent coordination.",
    image: "https://customer-assets.emergentagent.com/job_precision-at-scale/artifacts/qt1ff2nm_IMG_2825.jpeg",
    type: "foundation"
  },
  {
    id: "balaji-2009",
    year: "2009",
    company: "Balaji Telefilms",
    role: "Associate Supervising Producer",
    description: "Scaled operations across television and film synergy. Led multi-project operations and developed cross-platform content strategies.",
    type: "growth"
  },
  {
    id: "reliance-2010",
    year: "2010",
    company: "Reliance Entertainment",
    role: "Executive Producer",
    description: "Managed large-scale studio execution and film syndication. Oversaw non-fiction properties including flagship shows like Saregamapa.",
    type: "scale"
  },
  {
    id: "essel-2012",
    year: "2012-2014",
    company: "Essel Vision / Zee Entertainment Network",
    role: "Supervising Producer",
    description: "Drove media ecosystem expansion and business leadership. Multi-project production oversight across the Zee network.",
    type: "leadership"
  },
  {
    id: "zee-2017",
    year: "2017-Present",
    company: "Zee Studios Ltd",
    role: "Head of Productions - International",
    description: "Leading international production operations, live events, promos, non-fiction, and films. Strategic oversight of global production portfolio.",
    type: "executive",
    current: true
  }
];

export const industryNetwork = {
  title: "Industry & Market Network",
  description: "Strategic partnerships and market footprint across the global entertainment ecosystem",
  categories: [
    {
      id: "prod-houses",
      name: "Production Houses",
      partners: ["Zee Studios", "Reliance Entertainment", "Balaji Telefilms", "RGV Films", "Yashraj Films", "Sanjay Leela Bhansali Films"]
    },
    {
      id: "streaming",
      name: "Streaming Platforms",
      partners: ["Major OTT Platforms", "International Broadcasters", "Digital Distribution Networks"]
    },
    {
      id: "talent",
      name: "Talent Agencies",
      partners: ["500+ Celebrity Network", "Talent Management Firms", "Artist Representation"]
    },
    {
      id: "intl-markets",
      name: "International Markets",
      partners: ["UK & Europe", "Middle East", "Americas", "Asia-Pacific"]
    }
  ],
  marketFootprint: [
    { id: "mumbai", region: "Mumbai", role: "Production Hub" },
    { id: "south-asia", region: "South Asia", role: "Regional Leadership" },
    { id: "middle-east", region: "Middle East", role: "International Expansion" },
    { id: "uk-americas", region: "UK & Americas", role: "Co-production Partnerships" }
  ]
};

export const leadershipMandate = {
  title: "Leadership Mandate",
  vision: "Building sustainable, scalable entertainment businesses through strategic vision, operational excellence, and data-driven decision-making.",
  principles: [
    {
      id: "strategic-vision",
      title: "Strategic Vision & Executive Governance",
      description: "Establishing clear strategic roadmaps aligned with market dynamics and stakeholder expectations"
    },
    {
      id: "risk-mitigation",
      title: "Risk Mitigation in Media Investment",
      description: "Implementing robust risk assessment frameworks for content investment and production decisions"
    },
    {
      id: "scalable-ops",
      title: "Scalable Operational Frameworks",
      description: "Designing and deploying operational systems that enable growth without compromising quality or efficiency"
    }
  ]
};

export const potentialRoles = [
  {
    id: "head-prod",
    title: "Head of Productions",
    domain: "Film | Television | Media",
    description: "End-to-end production leadership for entertainment studios, broadcast networks, or OTT platforms"
  },
  {
    id: "vertical-head",
    title: "Vertical Head",
    domain: "Media & Entertainment Verticals",
    description: "Complete P&L ownership and strategic leadership for specific entertainment verticals"
  },
  {
    id: "business-head",
    title: "Business Head",
    domain: "Production | Content | Distribution",
    description: "Business leadership for media organizations with focus on revenue growth and operational excellence"
  },
  {
    id: "strategic-consultant",
    title: "Strategic Business Consultant",
    domain: "Entertainment | Film | Television",
    description: "Advisory and consulting for media companies on business strategy, operations, and growth initiatives"
  }
];

export const professionalMoments = [
  {
    image: "https://customer-assets.emergentagent.com/job_precision-at-scale/artifacts/deugk7gc_DC660060-F250-43F6-AD29-75E47FF4E7F3.jpeg",
    caption: "With Ranveer Singh - Bollywood Superstar",
    category: "Celebrity Collaboration"
  },
  {
    image: "https://customer-assets-agu9un31.emergentagent.net/job_precision-at-scale/artifacts/s8wngvmx_D1413F42-CFD1-4D87-B426-664276F6A450.PNG",
    caption: "Vijay Kadechkarr - Executive Portrait",
    category: "Professional"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_precision-at-scale/artifacts/qt1ff2nm_IMG_2825.jpeg",
    caption: "With Ram Gopal Varma - The Beginning (2005)",
    category: "Career Milestones"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_precision-at-scale/artifacts/tgnz2ygt_DC4BFB12-3424-46CD-9E50-CC2668CE0A6E.png",
    caption: "Executive Leadership",
    category: "Professional"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_precision-at-scale/artifacts/a2hdluvx_E180CBAB-D704-4E46-93DB-6458E0867E41.png",
    caption: "IIFTC Industry Leadership Speaking",
    category: "Thought Leadership"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_precision-at-scale/artifacts/lnfulveo_86635729-211a-43c5-bb5f-2ec0fcb75579.jpeg",
    caption: "With Union Minister Nitin Gadkari",
    category: "Government Relations"
  },
  {
    image: "https://customer-assets-agu9un31.emergentagent.net/job_precision-at-scale/artifacts/ys5tjxob_23BED30E-0733-4AC1-97C4-BA69AC8EAC21.webp",
    caption: "With Nitin Gadkari - Strategic Discussion",
    category: "Government Relations"
  },
  {
    image: "https://customer-assets-agu9un31.emergentagent.net/job_precision-at-scale/artifacts/inxrmvqb_5215bc0f-e67b-440c-a93e-1483570bcaea.jpg",
    caption: "Industry Event with Key Stakeholders",
    category: "Networking"
  },
  {
    image: "https://customer-assets-agu9un31.emergentagent.net/job_precision-at-scale/artifacts/q634678n_9E03D20F-342A-4621-BDBC-70FE4DACCF18%202.PNG",
    caption: "International Business Travel",
    category: "International"
  },
  {
    image: "https://customer-assets-agu9un31.emergentagent.net/job_precision-at-scale/artifacts/dbr4avyc_359F8FD7-A65D-4732-9E95-0FEEB3938FC7.PNG",
    caption: "Meeting with Eknath Shinde - Chief Minister of Maharashtra",
    category: "Government Relations"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_precision-at-scale/artifacts/mkja0q64_IMG_3011.jpeg",
    caption: "Political Event - Mass Production",
    category: "Large-Scale Events"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_precision-at-scale/artifacts/7xksosmw_IMG_8020.jpeg",
    caption: "Live Event Production",
    category: "Event Management"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_precision-at-scale/artifacts/2qauls5j_IMG_7681.jpeg",
    caption: "Large-Scale Celebrity Event",
    category: "Event Production"
  }
];
